<template>
    <svg xmlns="http://www.w3.org/2000/svg" class="e3-svg" :width="Number(size)" :height="Number(size)" viewBox="0 0 24 24">
        <path fill="currentColor" d="M20 2a2 2 0 012 2v12a2 2 0 01-2 2H6l-4 4V4a2 2 0 012-2h16m-9 4v3H8v2h3v3h2v-3h3V9h-3V6h-2z"/>
    </svg>
</template>

<script>
export default {
    name: 'MessagePlusIcon',
    props: {
        size: {
            type: [String, Number],
            default: 24
        }
    }
};
</script>
